import { render } from "./view_forms.html?vue&type=template&id=d1cc05e0&external"
import script from "./view_forms.js?vue&type=script&lang=js&external"
export * from "./view_forms.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__